import { render, staticRenderFns } from "./billWarehousing.vue?vue&type=template&id=27cf18a2&scoped=true"
import script from "./billWarehousing.vue?vue&type=script&lang=js"
export * from "./billWarehousing.vue?vue&type=script&lang=js"
import style0 from "./billWarehousing.vue?vue&type=style&index=0&id=27cf18a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf18a2",
  null
  
)

export default component.exports